// extracted by mini-css-extract-plugin
module.exports = {"custom_table":"topTable_custom_table__1ziJY","nodata":"topTable_nodata__15DYb"};